import TokenStore from "../stores/TokenStore";
import AppDispatcher from "../AppDispatcher";
import Constants from "../Constants";
import TableauAPI from "../util/TableauAPI";
import CurrentOrganizationIdStore from "../stores/CurrentOrganizationIdStore";

const TableauActions = {
  loadWorkbooksForCurrentOrg() {
    this.loadWorkbooks(CurrentOrganizationIdStore.getState());
  },

  loadWorkbooks(orgId) {
    new TableauAPI(TokenStore.getToken()).my
      .workbooks(orgId)
      .then((workbooks) => {
        AppDispatcher.dispatch({
          actionType: Constants.WORKBOOKS_RECEIVED,
          workbooks,
        });
      });
  },

  retrieveTicket(orgId = null) {
    if (!orgId) {
      orgId = CurrentOrganizationIdStore.getState();
    }
    return new TableauAPI(TokenStore.getToken()).my.ticket(orgId);
  },

  retrieveTicketForCurrentOrg() {
    return this.retrieveTicket();
  },
};

export default TableauActions;
